import React from "react";

function PlusIcon() {
  return (
    <div>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="stroke-[#353E5C] dark:stroke-white"
      >
        <path
          d="M10 2.5V17.5"
          // stroke="#353E5C"
          strokeWidth="1.32353"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5 10H2.5"
          // stroke="#353E5C"
          strokeWidth="1.32353"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}

export default PlusIcon;
